export const getMenu = store => (store.menu ? store.menu : {});
export const isLoaded = store => {
  let menu = getMenu(store);
  return menu.loaded != null && menu.loaded;
};
export const getMenus = store => getMenu(store).menus;
export const isUpdated = store => {
  let menu = getMenu(store);
  return menu.updated != null && menu.updated;
};